const chains = [];
chains.push({ _operation: 'getPaymentSystemTransactionCounts', api: '/payment-system-transaction-counts', defaultData: [], httpVerb: 'get' });
export default chains;
